// extracted by mini-css-extract-plugin
export default {"ButtonStyle":"ContextMenuStyle__ButtonStyle___3-lRc","ContextMenu":"ContextMenuStyle__ContextMenu___HMma7"};